import React from "react";
import { Link } from "react-router-dom";
import { SEOHeadV2 } from "../../components/SEOHeadV2";

const wrap = {
  minHeight: "100vh",
  background: "#0d1f3c",
  color: "#f4efe6",
  fontFamily: "Merriweather, Georgia, serif",
  display: "flex",
  alignItems: "center",
  justifyContent: "center",
  padding: 24,
};
const card = {
  maxWidth: 560,
  width: "100%",
  background: "#112244",
  border: "2px double #c9a84c",
  borderRadius: 10,
  padding: 32,
  textAlign: "center",
};
const h1 = {
  fontFamily: "Cinzel, Trajan Pro, Georgia, serif",
  color: "#c9a84c",
  fontSize: 32,
  letterSpacing: 2.5,
  margin: "0 0 16px 0",
  textTransform: "uppercase",
};
const p = { color: "#f4efe6", fontSize: 14, lineHeight: 1.7, marginBottom: 24 };
const btn = {
  display: "inline-block",
  background: "#c9a84c",
  color: "#0d1f3c",
  padding: "11px 24px",
  borderRadius: 4,
  fontFamily: "Cinzel, Georgia, serif",
  fontWeight: 600,
  letterSpacing: 1.4,
  textTransform: "uppercase",
  textDecoration: "none",
};

export const NotFound404 = () => (
  <div style={wrap} data-testid="page-404">
    <SEOHeadV2 title="Page Not Found — AuditIQ Sports" description="The page you are looking for does not exist or has been moved." />
    <div style={card}>
      <div style={{ color: "#c9a84c", fontSize: 11, letterSpacing: 3, marginBottom: 8 }}>404</div>
      <h1 style={h1} data-testid="page-404-title">Page Not Found</h1>
      <p style={p}>The page you are looking for does not exist or has been moved.</p>
      <Link to="/dashboard" style={btn} data-testid="page-404-cta">Return to Dashboard</Link>
    </div>
  </div>
);

export const Error500 = () => (
  <div style={wrap} data-testid="page-500">
    <SEOHeadV2 title="System Error — AuditIQ Sports" description="An unexpected system error has occurred. Our team has been notified." />
    <div style={card}>
      <div style={{ color: "#e74c3c", fontSize: 11, letterSpacing: 3, marginBottom: 8 }}>500</div>
      <h1 style={h1} data-testid="page-500-title">System Error</h1>
      <p style={p}>Our team has been notified. Please refresh or return to the dashboard.</p>
      <Link to="/dashboard" style={btn} data-testid="page-500-cta">Return to Dashboard</Link>
    </div>
  </div>
);

export const Maintenance = () => (
  <div style={wrap} data-testid="page-maintenance">
    <SEOHeadV2 title="Scheduled Maintenance — AuditIQ Sports" description="The AuditIQ Sports platform is undergoing scheduled maintenance and will return shortly." />
    <div style={card}>
      <div style={{ color: "#f39c12", fontSize: 11, letterSpacing: 3, marginBottom: 8 }}>MAINTENANCE</div>
      <h1 style={h1} data-testid="page-maintenance-title">Scheduled Maintenance</h1>
      <p style={p}>
        AuditIQ Sports is undergoing scheduled maintenance to improve reliability and performance.
        We will return shortly. Thank you for your patience.
      </p>
      <Link to="/" style={btn} data-testid="page-maintenance-cta">Back to Home</Link>
    </div>
  </div>
);
